module.exports = __webpack_public_path__ + "img/carpark_normal.654db530.png";